/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { InfigoModule } from '@dm/live-material-infigo';

import { CarouselComponent } from './carousel/carousel.component';
import { HistoryListComponent } from './history-list/history-list.component';
import { NasResourceComponent } from './svg-resource/nas-resource/nas-resource.component';
import { SanResourceComponent } from './svg-resource/san-resource/san-resource.component';


@NgModule({
    declarations: [
        HistoryListComponent,
        SanResourceComponent,
        NasResourceComponent,
        CarouselComponent,
    ],
    imports: [
        CommonModule,
        InfigoModule,
        CoreModule,
    ],
    exports: [
        HistoryListComponent,
        SanResourceComponent,
        NasResourceComponent,
        CarouselComponent,
    ],
})
export class InitStatusModule {
}
